import { Card, CardContent, CircularProgress, Icon, Typography } from '@material-ui/core';
import { Formik } from 'formik';
import { motion } from 'framer-motion';

// local imports
import { useCustomerListService, useQuery } from 'app/hooks/services';
import { CustomDataTable } from 'app/components/organisms/table';
import { FilterCustomers } from 'app/components/organisms/filter-forms';
import { EnvDefaults } from 'app/utils';

const tableQueries = {
  limit: 25,
  skip: 0,
  orderBy: 'name',
  sortBy: 'asc'
};

const CustomersList = () => {
  // end user - customer list service connection
  const { queries, handleFilterChange, handlePageChange, handleSort, isFilteringRef } =
    useQuery(tableQueries);

  const { service, handleRefresh } = useCustomerListService(queries, isFilteringRef);

  return (
    <>
      <motion.div initial={{ scale: 0, opacity: 0.2 }} animate={{ scale: 1, opacity: 1 }}>
        {/* Filter form */}
        <Card className="mb-16" elevation={4}>
          <CardContent>
            <div className="flex items-center">
              <Icon>filter_list</Icon>
              <Typography variant="subtitle1" className="text-gray-700 font-semibold mx-8">
                Filtrele
              </Typography>
              {isFilteringRef.current && (
                <CircularProgress color="secondary" size={22} thickness={6} />
              )}
            </div>

            <Formik initialValues={EnvDefaults.filterCustomersDefaults}>
              <FilterCustomers handleChange={handleFilterChange} />
            </Formik>
          </CardContent>
        </Card>

        <Card elevation={3}>
          <CardContent>
            <CustomDataTable
              defaultSortId={queries?.orderBy}
              defaultDirection={queries?.sortBy}
              service={service}
              queries={queries}
              handlePageChange={handlePageChange}
              handleChange={handleFilterChange}
              handleSort={handleSort}
              handleRefreshTable={handleRefresh}
            />
          </CardContent>
        </Card>
      </motion.div>
    </>
  );
};

export default CustomersList;
